import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import LoadingIndicator from "@cayuse/shared-react.components.loading-indicator";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";
import PropTypes from "prop-types";

import StartNewSubaward from "components/StartNewSubaward";
import DashboardView from "containers/DashboardView";
import { getSubawardsSummary } from "store/actions/subawardList";
import { subawardListSelectors } from "store/selectors";


const SubawardDashboard = ({ dashboardTilesAriaControls, searchFacets, onSearchChange, actualFacets }) => {
	const [ activeSummary, setActiveSummary ] = useState(null);
	const { search } = useSelector(subawardListSelectors.content);
	const { items, isFetching } = useSelector(subawardListSelectors.summary);

	useEffect(() => {
		getSubawardsSummary();
	}, []);

	useEffect(() => {
		if (search?.Status) {
			setActiveSummary(search?.Status);
		} else {
			setActiveSummary(null);
		}
	}, [ search ]);

	const onTileClick = value => {
		const activeSearch = search && search.val !== value
			? { Status: value }
			: {};
		const selectedFacets = actualFacets;
		selectedFacets.status = `"${value.toLowerCase()}"`;
		onSearchChange({ facetSearch: selectedFacets, facets: searchFacets });
		const activeSummary = isNonEmptyString(activeSearch.Status) ? activeSearch.Status : null;

		setActiveSummary(activeSummary);
	};

	if (isFetching) {
		return <LoadingIndicator />;
	}

	const headerButtons = [
		<StartNewSubaward key="startNewSubaward" />
	];

	return (
		<>
			<h3 className="accessibility-text">Subawards</h3>
			<p className="accessibility-text">
				Use the buttons to filter the list of subawards by status.
			</p>
			<DashboardView summary={items}
				onTileClick={onTileClick}
				activeTile={activeSummary}
				headerButtons={headerButtons}
				dashboardTopic="subawards"
				dashboardTilesAriaControls={dashboardTilesAriaControls}
			/>
		</>
	);
};

SubawardDashboard.propTypes = {
	dashboardTilesAriaControls: PropTypes.string
};

export default SubawardDashboard;
